export default __webpack_public_path__ + "static/media/Marketing_Data.7e7af95b.png";